import { createStore } from '@raiz/react-simple-store'

const pages = 26.4
const additionnalPage = 0.2

function scaleFactorize(value) {
    const absolute = value * pages;
    const totalPages = pages + additionnalPage;
    return absolute / totalPages;
}
    
    

const state = {

    lang: 'en',

    isUiHidden: true,

    page: pages,
    additionnalPage: additionnalPage,
    totalPages: pages + additionnalPage,


    damping: 0.2,

    chapterChangeRequested: false,
    preventChapterUpdate: false,

    current: {
        chapter: 'null',
        dates: [null, null],
        start: null
    },



    scrollMap: {
        one: scaleFactorize(.106),
        two: scaleFactorize(.264),
        three: scaleFactorize(.488),
        four: scaleFactorize(.783),
        five:scaleFactorize(1)
    },

    chapters: [
        {
            name:
            {
                fr: 'GENÈSE',
                en: 'ORIGINS'
            }
            , dates: [1984, 1990],
            start: 0
        },
        {
            name:
            {
                fr: 'UNICITÉ',
                en: 'UNICITY'
            }
            , dates: [1990, 2000],
            start: 0.142662355370291
        },
        {
            name:
            {
                fr: 'EXPANSION',
                en: 'EXPANSION'
            }
            , dates: [2000, 2010],
            start: 0.29257080525147067
        },
        {
            name:
            {
                fr: 'RAYONNEMENT',
                en: 'OUTREACH'
            }
            , dates: [2010, 2020],
            start: 0.5125248354045736
        },
        {
            name:
            {
                fr: 'PERSPECTIVES',
                en: 'VISION'
            }
            , dates: [2020, 2026],
            start: 0.8066149830534887
        },
    ],

    colors: {
        clear: "#ffffef",
        title: '#1d1d1d',

        primary: "#4E9784",
        secondary: '#B3D0B8'
    },

    fonts: {
        cm: {
            title: import.meta.env.BASE_URL + 'fonts/cormorant/cormorant-v21-latin-regular.woff',
            text: import.meta.env.BASE_URL + 'fonts/cormorant/cormorant-v21-latin-regular.woff',
            titleBold: import.meta.env.BASE_URL + 'fonts/cormorant/cormorant-v21-latin-700.woff',
            legend: import.meta.env.BASE_URL + 'fonts/cormorant/cormorant-v21-latin-italic.woff',
        },

        ms: {
            title: import.meta.env.BASE_URL + 'fonts/montserrat/montserrat-v26-latin-500.woff',
            text: import.meta.env.BASE_URL + 'fonts/montserrat/montserrat-v26-latin-regular.woff',
            italic: import.meta.env.BASE_URL + 'fonts/montserrat/montserrat-v26-latin-italic.woff'
        },
        cd: {
            title: import.meta.env.BASE_URL + 'fonts/cedarville/cedarville-cursive-v17-latin-regular.woff'
        }

    }
}

const actions = (set, get) => {
    return {
        setLang: (lang) => set({ lang: lang }),
        reveal: () => set({ isUiHidden: false }),
        hide: () => set({ isUiHidden: true }),
        setChapterChangeRequested: (boolean = true) => set({ chapterChangeRequested: boolean }),
        setDamping: (number) => set({ damping: number }),
        selectChapter: (chapter, dates, start = 0) => set({ current: { chapter, dates: dates, start: start } }),
        preventChapterUpdate: (boolean = true) => set({ preventChapterUpdate: boolean }),
    };
};



export const mainStore = createStore({ actions, state });


